import { connect } from 'react-redux'
import { hideNavigation, setCurrentSearchPhrase, setSearchHelperVisible } from 'redux/actions'
import { setSmartSearchEnabled } from 'redux/actions/search'
import SearchBox from 'components/layout/search/SearchBox'

const mapStateToProps = state => ({
  currentSearchPhrase: state.search.currentSearchPhrase,
  displayName: state.search.displayName,
  searchTypeClasses: state.search.searchTypeClasses,
  searchHelperVisible: state.search.searchHelperVisible,
  smartSearchEnabled: state.search.smartSearchEnabled
})

const mapDispatchToProps = dispatch => ({
  hideNavigation: () => dispatch(hideNavigation()),
  setCurrentSearchPhrase: searchPhrase => dispatch(setCurrentSearchPhrase(searchPhrase)),
  setSearchHelperVisible: searchHelperVisible => dispatch(setSearchHelperVisible(searchHelperVisible)),
  setSmartSearchEnabled: enabled => dispatch(setSmartSearchEnabled(enabled))
})

export default connect(mapStateToProps, mapDispatchToProps)(SearchBox)
